var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { SET_APP_CONTEXT } from '../constants';
import { REQUEST_SERVICE_UPDATE, REQUEST_VIDEO_ADD, REQUEST_VIDEO_DELETE, REQUEST_VIDEO_REORDER, SET_SERVICE, VIDEO_ADD, VIDEO_DELETE, VIDEO_REORDER, } from './constants';
import { PHOTO_DELETE, PHOTO_UPLOAD, PHOTOS_REORDER } from '../../+edit/photos/store/ui/constants';
export function serviceReducer(state, action) {
    if (state === void 0) { state = null; }
    switch (action.type) {
        case SET_APP_CONTEXT:
            return action.payload.service;
        case SET_SERVICE:
            return action.payload.res;
        case PHOTO_UPLOAD:
            return __assign({}, state, { photos: [action.payload.photo].concat(state.photos) });
        case PHOTO_DELETE: {
            var photoIndex = state.photos.findIndex(function (photo) { return photo.id === action.payload; });
            var photos = state.photos.slice(0, photoIndex).concat(state.photos.slice(photoIndex + 1));
            return __assign({}, state, { photos: photos });
        }
        case PHOTOS_REORDER:
            return __assign({}, state, { photos: action.payload });
        case VIDEO_ADD:
            return __assign({}, state, { videos: [action.payload].concat(state.videos) });
        case VIDEO_DELETE: {
            var videoIndex = state.videos.findIndex(function (video) { return video.id === action.payload; });
            var videos = state.videos.slice(0, videoIndex).concat(state.videos.slice(videoIndex + 1));
            return __assign({}, state, { videos: videos });
        }
        default:
            return state;
    }
}
var SetServiceAction = /** @class */ (function () {
    function SetServiceAction(payload) {
        this.payload = payload;
        this.type = SET_SERVICE;
    }
    return SetServiceAction;
}());
export { SetServiceAction };
var RequestServiceUpdateAction = /** @class */ (function () {
    function RequestServiceUpdateAction(payload) {
        this.payload = payload;
        this.type = REQUEST_SERVICE_UPDATE;
    }
    return RequestServiceUpdateAction;
}());
export { RequestServiceUpdateAction };
var RequestVideoAddAction = /** @class */ (function () {
    function RequestVideoAddAction(payload) {
        this.payload = payload;
        this.type = REQUEST_VIDEO_ADD;
    }
    return RequestVideoAddAction;
}());
export { RequestVideoAddAction };
var VideoAddAction = /** @class */ (function () {
    function VideoAddAction(payload) {
        this.payload = payload;
        this.type = VIDEO_ADD;
    }
    return VideoAddAction;
}());
export { VideoAddAction };
var RequestVideoDeleteAction = /** @class */ (function () {
    function RequestVideoDeleteAction(payload) {
        this.payload = payload;
        this.type = REQUEST_VIDEO_DELETE;
    }
    return RequestVideoDeleteAction;
}());
export { RequestVideoDeleteAction };
var VideoDeleteAction = /** @class */ (function () {
    function VideoDeleteAction(payload) {
        this.payload = payload;
        this.type = VIDEO_DELETE;
    }
    return VideoDeleteAction;
}());
export { VideoDeleteAction };
var RequestVideosReorderAction = /** @class */ (function () {
    function RequestVideosReorderAction(payload) {
        this.payload = payload;
        this.type = REQUEST_VIDEO_REORDER;
    }
    return RequestVideosReorderAction;
}());
export { RequestVideosReorderAction };
var VideosReorderAction = /** @class */ (function () {
    function VideosReorderAction(payload) {
        this.payload = payload;
        this.type = VIDEO_REORDER;
    }
    return VideosReorderAction;
}());
export { VideosReorderAction };
